import {
  SEND_EMAIL,
  SEND_EMAIL_SUCCESSFUL,
  SEND_EMAIL_FAILED
} from "./actionTypes"

export const sendEmail = (data, callback) => {
  return {
    type: SEND_EMAIL,
    payload: { data, callback },
  }
}

export const sendEmailSuccessful = data => {
  return {
    type: SEND_EMAIL_SUCCESSFUL,
    payload: data,
  }
}

export const sendEmailFailed = data => {
  return {
    type: SEND_EMAIL_FAILED,
    payload: data,
  }
}